import { createContext, useContext } from 'react'

export const IsTemplateContext = createContext<boolean | undefined>(undefined)

export const useIsTemplateContext = () => useContext(IsTemplateContext) as boolean
